import {Component, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
    selector: 'evk-firma-electronica-dialog',
    templateUrl: './evk-firma-electronica-dialog.component.html',
    styleUrls: ['./evk-firma-electronica-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class EvkFirmaElectronicaDialogComponent implements OnInit {

    public hash: string;
    public message: string;
    public encode: string;
    public idDiligencia: string;
    public username: string;
    public rfc: string;

    private signedMessageFirma: any;

    constructor(
        public dialogRef: MatDialogRef<EvkFirmaElectronicaDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.hash = data.datos.hash;
        this.message = data.datos.message;
        this.encode = data.datos.encode;
        this.idDiligencia = data.datos.idDiligencia;
        this.username = data.datos.username;
        this.rfc = data.datos.rfc;
    }

    ngOnInit() {
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    valid($event: any) {
        this.closeDialogReturn($event, this.signedMessageFirma);
    }

    signedMessage($event: any) {
        //Recibe el objeto de la validacion
        this.signedMessageFirma = $event;
    }

    errorMessage($event: any) {
        this.closeDialogReturn(false, $event);
    }

    loading($event: any) {
    }

    closeDialogReturn(valid: boolean, message: any) {
        this.dialogRef.close({
            valid,
            message
        });
    }
}
